import { extractTimeFromDateTimeParam } from './datetime';
import type { AppointmentData } from './validation';

export interface ParsedParams {
  data: AppointmentData;
  hasQS: boolean;
}

export function parseParams(params: Record<string, string>): ParsedParams {
  const firstName = params.firstName || params.firstname || '';
  const lastName = params.lastName || params.lastname || '';
  const department = params.department || '';
  const dateTimeRaw = params.dateTime || params.datetime || '';
  const time = dateTimeRaw ? extractTimeFromDateTimeParam(dateTimeRaw) : '';

  if (firstName && lastName && department && time) {
    return {
      data: { firstName, lastName, department, time },
      hasQS: true,
    };
  }
  return {
    data: { firstName: '', lastName: '', department: '', time: '' },
    hasQS: false,
  };
}
